import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { FiSun, FiMoon } from 'react-icons/fi';

const ThemeToggleIcon = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <button
      className="p-3 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
      onClick={toggleTheme}
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDarkMode ? (
        <FiSun className="text-xl text-yellow-500 hover:rotate-90 transition-transform duration-500" />
      ) : (
        <FiMoon className="text-xl text-gray-700 hover:-rotate-12 transition-transform duration-500" />
      )}
    </button>
  );
};

export default ThemeToggleIcon;
